import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

/**
 * Admin Story 17, AC-04: an admin who lacks InstitutionSetting access (e.g. Instruction
 * Admin) sees this sentence on page open, matching the API's 403. Instructors and other
 * non-admins keep the generic Access Denied copy — NoAccess only applies this meta when
 * the signed-in user is an admin role (Owner / Admin / Instruction Admin).
 */
export const attendSettingsDenialMessage = "You don't have permission to change attendance settings.";

export default [
    {
        path: '/attendance-settings',
        name: 'attendance-settings',
        beforeEnter: FeatureMiddleware('ATTEND'),
        component: () => import('@/pages/administration/AttendSettings.vue'),
        meta: {
            title: 'Attendance Settings',
            breadcrumb: ['Administration', 'Attendance'],
            middleware: [GateKeeperMiddleware],
            ability: ({ gate }) => gate.allows('view', 'InstitutionSetting'),
            denialMessage: attendSettingsDenialMessage,
            denialMessageForAdminRolesOnly: true,
        },
    },
];
